import { useEffect, useState } from "react";
import { api, fmt } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { druhLabel } from "@/lib/druh";
import { Search } from "lucide-react";

export function MaterialPicker({ open, onOpenChange, onAdd }) {
  const [mats, setMats] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState({});

  useEffect(() => {
    if (!open) { setSelected({}); setSearch(""); }
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => {
      api.get("/materials", { params: search ? { search } : {} }).then((r) => setMats(r.data.materials));
    }, 250);
    return () => clearTimeout(t);
  }, [search, open]);

  const toggle = (m) => setSelected((s) => ({ ...s, [m.code]: s[m.code] ? undefined : m }));
  const confirm = () => {
    const chosen = Object.values(selected).filter(Boolean);
    if (chosen.length) onAdd(chosen);
    onOpenChange(false);
  };
  const count = Object.values(selected).filter(Boolean).length;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader><DialogTitle className="font-display">Přidat suroviny z číselníku</DialogTitle></DialogHeader>
        <div className="relative">
          <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input data-testid="picker-search" placeholder="Hledat…" value={search}
            onChange={(e) => setSearch(e.target.value)} className="pl-9" autoFocus />
        </div>
        <div className="max-h-80 overflow-auto border border-border rounded-lg divide-y divide-border">
          {mats.slice(0, 100).map((m) => (
            <button key={m.code} data-testid={`picker-item-${m.code}`} onClick={() => toggle(m)}
              className={`w-full flex items-center justify-between px-4 py-2.5 text-left transition-colors ${selected[m.code] ? "bg-primary/10" : "hover:bg-muted"}`}>
              <div>
                <div className="text-sm font-medium">{m.name}</div>
                <div className="text-xs text-muted-foreground num">{m.code} · {m.category} · {druhLabel(m.druh)}</div>
              </div>
              <div className="num text-sm font-semibold">{fmt(m.computed_price)} Kč/{m.unit}</div>
            </button>
          ))}
          {mats.length === 0 && <div className="px-4 py-8 text-center text-sm text-muted-foreground">Nic nenalezeno.</div>}
        </div>
        <div className="flex justify-end gap-2 pt-1">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Zrušit</Button>
          <Button onClick={confirm} disabled={!count} data-testid="picker-confirm">Přidat {count > 0 ? `(${count})` : ""}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
